<!-- Báo cáo truyện từ độc giả: người đọc báo cáo -> tác giả khắc phục -> admin xử lý -->
<template>
  <div class="d-flex flex-column flex-root">
    <div class="page d-flex flex-row flex-column-fluid">
      <div class="wrapper d-flex flex-column flex-row-fluid" id="kt_wrapper">
        <div id="kt_header" class="header">
          <div class="container-fluid d-flex align-items-center flex-wrap justify-content-between"
               id="kt_header_container">
            <div class="page-title d-flex flex-column align-items-start justify-content-center flex-wrap me-2 pb-5 pb-lg-0 pt-7 pt-lg-0">
              <h1 class="d-flex flex-column text-dark fw-bolder my-0">Báo cáo truyện
                <small class="text-muted fs-6 fw-bold ms-1 pt-1">Số lượng {{ $numberFormat(items.metaData?.total) }}</small>
              </h1>
            </div>
          </div>
        </div>

        <div class="content d-flex flex-column flex-column-fluid" id="kt_content">
          <div class="container-fluid" id="kt_content_container">
            <div class="card card-flush">
              <!-- Bộ lọc -->
              <div class="card-header align-items-center py-5 gap-2 gap-md-5">
                <div class="card-toolbar flex-row-fluid justify-content-start gap-3 flex-wrap">
                  <div class="w-100 mw-200px">
                    <label class="form-label small text-muted mb-1">Trạng thái báo cáo</label>
                    <select class="form-select form-select-solid" v-model="filter.state" @change="search">
                      <option v-for="o in stateOptions" :key="o.value" :value="o.value">{{ o.label }}</option>
                    </select>
                  </div>
                  <div class="w-100 mw-200px">
                    <label class="form-label small text-muted mb-1">Phía tác giả</label>
                    <select class="form-select form-select-solid" v-model="filter.authorStatus" @change="search">
                      <option v-for="o in authorStatusOptions" :key="o.value" :value="o.value">{{ o.label }}</option>
                    </select>
                  </div>
                  <div class="w-100 mw-250px">
                    <label class="form-label small text-muted mb-1">Lý do</label>
                    <select class="form-select form-select-solid" v-model="filter.reason" @change="search">
                      <option value="">Tất cả</option>
                      <option v-for="(label, key) in reasons" :key="key" :value="key">{{ label }}</option>
                    </select>
                  </div>
                  <div class="w-100 mw-150px">
                    <label class="form-label small text-muted mb-1">ID truyện</label>
                    <input class="form-control form-control-solid" type="number" v-model="filter.storyId"
                           placeholder="VD: 1234" @keyup.enter="search">
                  </div>
                  <div class="align-self-end">
                    <button class="btn btn-light-primary" @click="search" :disabled="loading">
                      <span v-if="loading" class="spinner-border spinner-border-sm"></span> Lọc
                    </button>
                  </div>
                </div>
              </div>

              <div class="card-body pt-0">
                <div class="table-responsive">
                  <table class="table align-middle table-row-dashed fs-6 gy-4">
                    <thead>
                    <tr class="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
                      <th class="min-w-200px">Truyện</th>
                      <th class="min-w-200px">Lý do</th>
                      <th>Người báo cáo</th>
                      <th class="text-center">Thời gian</th>
                      <th class="min-w-200px">Phía tác giả</th>
                      <th class="text-center">Báo cáo</th>
                      <th class="text-end min-w-150px">Hành động</th>
                    </tr>
                    </thead>
                    <tbody class="fw-bold text-gray-600">
                    <tr v-if="!loading && !items.data.length">
                      <td colspan="7" class="text-center text-muted py-10">Không có báo cáo nào</td>
                    </tr>
                    <tr v-for="item in items.data" :key="item.id">
                      <td>
                        <template v-if="item.story">
                          <a :href="$webUrl(item.story.slug || 'truyen', item.story.id)" target="_blank"
                             class="fw-bold text-black text-hover-primary">{{ item.story.name }}</a>
                          <div class="small text-muted">#{{ item.story.id }}
                            <span v-if="item.story.author"> · {{ item.story.author.name }}</span>
                          </div>
                          <span class="badge" :class="storyStateBadge(item.story.state).cls">{{ storyStateBadge(item.story.state).label }}</span>
                        </template>
                        <span v-else class="text-muted">Truyện #{{ item.storyId }} (không tồn tại)</span>
                      </td>
                      <td>
                        <div class="text-dark">{{ reasons[item.reason] || item.reason }}</div>
                        <div v-if="item.chapter" class="small text-muted">Chương {{ item.chapter }}</div>
                        <div v-if="item.content" class="small text-gray-700 text-break report-content">“{{ item.content }}”</div>
                      </td>
                      <td>
                        <a v-if="item.email" :href="'mailto:' + item.email" class="text-break">{{ item.email }}</a>
                        <span v-else class="text-muted">—</span>
                        <div v-if="item.userId" class="small text-muted">user #{{ item.userId }}</div>
                        <div v-else class="small text-muted">Khách</div>
                      </td>
                      <td class="text-center text-nowrap">{{ $formatDateTime2(item.createdAt) }}</td>
                      <td>
                        <span class="badge" :class="authorBadge(item).cls">{{ authorBadge(item).label }}</span>
                        <div v-if="item.authorNote" class="small text-gray-700 text-break mt-1">{{ item.authorNote }}</div>
                        <div v-if="item.authorRespondedAt" class="small text-muted">{{ $formatDateTime2(item.authorRespondedAt) }}</div>
                        <div v-if="item.adminRequestedAt" class="small text-warning mt-1">
                          Đã yêu cầu tác giả: {{ $formatDateTime2(item.adminRequestedAt) }}
                        </div>
                      </td>
                      <td class="text-center">
                        <span class="badge" :class="stateBadge(item).cls">{{ stateBadge(item).label }}</span>
                        <div v-if="item.adminNote && item.state !== 'PENDING'" class="small text-muted text-break mt-1">{{ item.adminNote }}</div>
                      </td>
                      <td class="text-end">
                        <div v-if="item.state === 'PENDING'" class="d-flex flex-column gap-1 align-items-end">
                          <button class="btn btn-sm btn-light-warning" @click="openAction(item, 'request-author')">Yêu cầu tác giả xử lý</button>
                          <button class="btn btn-sm btn-light-danger" @click="openAction(item, 'take-down')"
                                  :disabled="!item.story || item.story.state === 'LOCK'">Gỡ truyện</button>
                          <div class="d-flex gap-1">
                            <button class="btn btn-sm btn-light-success" @click="openAction(item, 'close')">Đóng</button>
                            <button class="btn btn-sm btn-light" @click="openAction(item, 'ignore')">Bỏ qua</button>
                          </div>
                        </div>
                        <span v-else class="text-muted small">{{ adminActionLabel(item.adminAction) }}</span>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>

                <!-- Phân trang -->
                <div class="d-flex justify-content-between align-items-center mt-4" v-if="items.metaData?.totalPage > 1">
                  <span class="text-muted small">Trang {{ filter.page + 1 }} / {{ items.metaData.totalPage }}</span>
                  <div class="d-flex gap-2">
                    <button class="btn btn-sm btn-light" :disabled="filter.page === 0 || loading" @click="goPage(filter.page - 1)">‹ Trước</button>
                    <button class="btn btn-sm btn-light" :disabled="filter.page + 1 >= items.metaData.totalPage || loading" @click="goPage(filter.page + 1)">Sau ›</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal v-model="action.visible" :title="actionMeta.title" centered hide-footer>
      <div v-if="action.item">
        <div class="mb-3">
          <div class="fw-bold">{{ action.item.story?.name || ('Truyện #' + action.item.storyId) }}</div>
          <div class="small text-muted">{{ reasons[action.item.reason] || action.item.reason }}</div>
        </div>
        <div class="alert" :class="actionMeta.alert">{{ actionMeta.desc }}</div>
        <label class="form-label">{{ actionMeta.noteLabel }}</label>
        <textarea class="form-control" rows="3" maxlength="1000" v-model="action.note"
                  :placeholder="actionMeta.placeholder"></textarea>
        <div class="text-end mt-4">
          <button class="btn btn-light me-2" @click="action.visible = false">Huỷ</button>
          <button class="btn" :class="actionMeta.btn" :disabled="action.sending" @click="submitAction">
            <span v-if="action.sending" class="spinner-border spinner-border-sm"></span> {{ actionMeta.confirm }}
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import requestUtil from "@/utils/request-util";

const REASONS = {
  INAPPROPRIATE_CONTENT: 'Nội dung phản cảm (18+, bạo lực, kích động…)',
  COPYRIGHT_VIOLATION: 'Vi phạm bản quyền',
  SPAM_ADVERTISEMENT: 'Spam / Quảng cáo',
  INCORRECT_CATEGORY: 'Sai thể loại / Nội dung',
  STORY_NOT_READABLE: 'Truyện không thể đọc (thiếu chương, lỗi hiển thị…)',
  MISLEADING_TITLE: 'Tiêu đề hoặc mô tả gây hiểu lầm',
  INAPPROPRIATE_LANGUAGE: 'Ngôn ngữ không phù hợp (tục tĩu, xúc phạm…)',
  OTHER: 'Khác',
};

const ACTIONS = {
  'request-author': {
    title: 'Yêu cầu tác giả xử lý', confirm: 'Gửi yêu cầu', btn: 'btn-warning', alert: 'alert-warning',
    desc: 'Tác giả sẽ nhận thông báo và truyện được đánh dấu chấm đỏ cho tới khi tác giả phản hồi.',
    noteLabel: 'Ghi chú cho tác giả (tuỳ chọn)', placeholder: 'VD: Vui lòng gỡ chương 12 có nội dung 18+',
  },
  'take-down': {
    title: 'Gỡ truyện', confirm: 'Gỡ truyện', btn: 'btn-danger', alert: 'alert-danger',
    desc: 'Truyện sẽ bị khoá (không xoá), tác giả nhận thông báo. Tất cả báo cáo đang mở của truyện này được đóng.',
    noteLabel: 'Lý do gỡ (gửi cho tác giả, bỏ trống sẽ dùng lý do báo cáo)', placeholder: 'VD: Vi phạm bản quyền',
  },
  close: {
    title: 'Đóng báo cáo', confirm: 'Đóng báo cáo', btn: 'btn-success', alert: 'alert-success',
    desc: 'Đánh dấu báo cáo đã được xử lý xong.',
    noteLabel: 'Ghi chú (tuỳ chọn)', placeholder: 'VD: Tác giả đã sửa tiêu đề',
  },
  ignore: {
    title: 'Bỏ qua báo cáo', confirm: 'Bỏ qua', btn: 'btn-secondary', alert: 'alert-secondary',
    desc: 'Báo cáo không hợp lệ / truyện không vi phạm.',
    noteLabel: 'Ghi chú (tuỳ chọn)', placeholder: 'VD: Nội dung không vi phạm',
  },
};

export default {
  name: "StoryReport",
  data() {
    return {
      reasons: REASONS,
      stateOptions: [
        {value: 'PENDING', label: 'Đang mở'},
        {value: 'OK', label: 'Đã đóng / Đã gỡ'},
        {value: 'REJECT', label: 'Đã bỏ qua'},
        {value: '', label: 'Tất cả'},
      ],
      authorStatusOptions: [
        {value: '', label: 'Tất cả'},
        {value: 'PENDING', label: 'Chưa xử lý'},
        {value: 'FIXED', label: 'Đã khắc phục'},
        {value: 'NOT_FIXED', label: 'Không khắc phục'},
      ],
      filter: {state: 'PENDING', authorStatus: '', reason: '', storyId: '', page: 0, size: 20},
      items: {data: [], metaData: {}},
      loading: false,
      action: {visible: false, type: null, item: null, note: '', sending: false},
    };
  },
  computed: {
    actionMeta() {
      return ACTIONS[this.action.type] || ACTIONS.close;
    },
  },
  mounted() {
    this.fetchItems();
  },
  methods: {
    search() {
      this.filter.page = 0;
      this.fetchItems();
    },
    goPage(page) {
      this.filter.page = page;
      this.fetchItems();
    },
    async fetchItems() {
      this.loading = true;
      const params = {page: this.filter.page, size: this.filter.size};
      ['state', 'authorStatus', 'reason', 'storyId'].forEach((k) => {
        if (this.filter[k] !== '' && this.filter[k] !== null) params[k] = this.filter[k];
      });
      try {
        const response = await requestUtil.get('/admin/story-report', params);
        this.items = response.data;
      } catch (e) {
        this.$notify({title: 'Có lỗi xảy ra', type: 'error', text: e.message || 'Không tải được danh sách báo cáo'});
      } finally {
        this.loading = false;
      }
    },
    openAction(item, type) {
      this.action = {visible: true, type, item, note: '', sending: false};
    },
    async submitAction() {
      const {item, type, note} = this.action;
      this.action.sending = true;
      try {
        await requestUtil.post(`/admin/story-report/${item.id}/${type}`, {note: note || null});
        this.$notify({title: 'Thành công', type: 'success', text: this.actionMeta.title});
        this.action.visible = false;
        await this.fetchItems();
      } catch (e) {
        this.$notify({title: 'Có lỗi xảy ra', type: 'error', text: e.message || 'Vui lòng thử lại'});
      } finally {
        this.action.sending = false;
      }
    },
    authorBadge(item) {
      if (item.authorStatus === 'FIXED') return {label: 'Đã khắc phục', cls: 'badge-light-success'};
      if (item.authorStatus === 'NOT_FIXED') return {label: 'Không khắc phục', cls: 'badge-light-danger'};
      return {label: 'Chưa xử lý', cls: 'badge-light-warning'};
    },
    stateBadge(item) {
      if (item.state === 'OK') return item.adminAction === 'TAKE_DOWN'
          ? {label: 'Đã gỡ truyện', cls: 'badge-light-danger'}
          : {label: 'Đã đóng', cls: 'badge-light-success'};
      if (item.state === 'REJECT') return {label: 'Bỏ qua', cls: 'badge-light-dark'};
      return {label: 'Đang mở', cls: 'badge-light-primary'};
    },
    storyStateBadge(state) {
      const map = {
        APPROVED: {label: 'Công khai', cls: 'badge-light-success'},
        UN_PUBLIC: {label: 'Riêng tư', cls: 'badge-light-dark'},
        REJECT: {label: 'Từ chối', cls: 'badge-light-danger'},
        PENDING: {label: 'Chờ duyệt', cls: 'badge-light-warning'},
        DRAFT: {label: 'Nháp', cls: 'badge-light-secondary'},
        DELETE: {label: 'Đã xoá', cls: 'badge-light-secondary'},
        LOCK: {label: 'Đã khoá', cls: 'badge-light-danger'},
      };
      return map[state] || {label: state || '', cls: 'badge-light'};
    },
    adminActionLabel(action) {
      return {
        TAKE_DOWN: 'Đã gỡ truyện',
        CLOSE: 'Đã đóng',
        IGNORE: 'Đã bỏ qua',
        REQUEST_AUTHOR: 'Đã yêu cầu tác giả',
      }[action] || '';
    },
  },
};
</script>

<style scoped>
.report-content {
  max-width: 320px;
  white-space: pre-line;
}
</style>
